import React, { Component } from "react";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import "../style/about.scss";

class Privacy extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <React.Fragment>
        <HeaderBar {...this.props} />
        <div className="about-page">
          <div className="about-contain">
            <div className="title"></div>
            <div className="about-tent">
              <div className="left"></div>
              <div className="right">
                <h1>Our Privacy Policy</h1>
                <p>
                  Folksy complies with the principles of the General Data
                  Protection Regulations (GDPR) when dealing with all data
                  received from visitors to the site. We only hold the data
                  necessary to offer services provided on our website namely to
                  allow users of the service to buy and sell and also message
                  one another. We also keep user data to allow us to contact you
                  in the advent of account withdrawal or new passwords being
                  provided.
                </p>
                <p>
                  We only hold personal data for as long as necessary. Once data
                  is no longer needed it is deleted from our files. If you
                  delete your account then all your personal data will be
                  deleted too.
                </p>
                <p>
                  For administrative reasons email subscription data may be
                  passed to and stored securely with third party service
                  providers located outside the EEA (European Economic Area).
                </p>
                <p>
                  We regularly email news and information updates to those
                  customers who have specifically subscribed to our email
                  service. All subscription emails sent by us contain clear
                  information on how to unsubscribe from our email service.
                </p>
                <p>
                  <b>We never sell, rent or exchange mailing lists.</b>
                </p>
                <p>
                  We may however share commercial and technical data with our
                  partners where a customer has accessed and used our website.
                  This data would not be personal data but would be anonymised
                  [for example the kind of data you see in “Google Analytics”].
                </p>
                <p>
                  In accordance with the Privacy and Electronic Communications
                  (EC Directive) Regulations 2003, we never send bulk
                  unsolicited emails, (popularly known as Spam) to email
                  addresses.
                </p>
                <p>
                  We may send emails to existing customers or prospective
                  customers who have enquired or registered with us, regarding
                  products or services directly provided by us.
                </p>
                <p>
                  All emails sent by us will be clearly marked as originating
                  from us. All such emails will also include clear instructions
                  on how unsubscribe from our email service and any future
                  emails. Such instructions will either include a link to a page
                  to unsubscribe or a valid email address to which you should
                  reply, with “unsubscribe” as the email subject heading.
                </p>
                <p>
                  Our website uses “cookies” to track use and allow customers to
                  purchase from our website. Please note that these cookies do
                  not contain or pass any personal, confidential or financial
                  information or any other information that could be used to
                  identify individual visitors or customers purchasing from our
                  website. Please note that you are free to refuse cookies.
                  However, for purely technical reasons this may prevent you
                  from purchasing from our website. This is because anonymous
                  cookies are commonly used to keep track of the contents of
                  customers’ shopping baskets or trolleys during the checkout
                  process. This facility ensures that the items added to (or
                  removed from) your basket are accurately stated when you go to
                  pay.
                </p>
                <p>
                  We’ve tried to abide by the policies set out by the Campaign
                  for Plain English. If you have any questions relating to our
                  Privacy Policy please contact us via the Helpdesk.
                </p>
              </div>
            </div>
          </div>
        </div>
        <FooterBar {...this.props} />
      </React.Fragment>
    );
  }
}

export default Privacy;
